import { render, staticRenderFns } from "./GavHolidays.vue?vue&type=template&id=100faa51&scoped=true"
import script from "./GavHolidays.vue?vue&type=script&lang=js"
export * from "./GavHolidays.vue?vue&type=script&lang=js"
import style0 from "./GavHolidays.vue?vue&type=style&index=0&id=100faa51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100faa51",
  null
  
)

export default component.exports